module.exports = __webpack_public_path__ + "static/img/no-search@2x.419fa300.png";